import { get } from 'lodash';
import { logout, refreshToken, setTokenExpirationIntervalId, tokenExpirationCheck } from '../../screens/Login/actions';
import { actions as idleActions } from '../services/ReduxIdleMonitor';
import { BASIC_PROVIDER_TYPE } from '../constants/authProvider';

const CHECK_EXPIRATION_TIMEOUT_MINUTES = 1;
const CHECK_EXPIRATION_TIMEOUT_MILLISECONDS = CHECK_EXPIRATION_TIMEOUT_MINUTES * 60 * 1000;
const REFRESH_DIALOG_TIMEOUT_MILLISECONDS = 2 * 60 * 1000;

const checkTokenExpiration = (store) => {
  const state = store.getState();
  const { user } = state.login;
  const expirationTime = user.exp * 1000;
  const now = Date.now();

  if (expirationTime - now <= 0) {
    store.dispatch(logout());
  } else if (expirationTime - now <= REFRESH_DIALOG_TIMEOUT_MILLISECONDS) {
    store.dispatch(refreshToken());
  }

  store.dispatch(tokenExpirationCheck(now));
};

const clearTokenInterval = (store) => {
  const state = store.getState();

  if (state.login.tokenExpirationIntervalId) {
    clearInterval(state.login.tokenExpirationIntervalId);
  }
};
const setTokenInterval = (store) => {
  clearTokenInterval(store);
  const tokenExpirationIntervalId = setInterval(checkTokenExpiration.bind(this, store), CHECK_EXPIRATION_TIMEOUT_MILLISECONDS);

  store.dispatch(setTokenExpirationIntervalId(tokenExpirationIntervalId));
};

const authProviderLogout = (store) => {
  const state = store.getState();
  const authProviders = get(state, 'appConfig.config.authProviders');
  const loggedInProviderType = get(state, 'login.user.authProvider.type');
  const loggedInProvider =
    authProviders && authProviders.length && loggedInProviderType
      ? authProviders.find((provider) => provider.type === loggedInProviderType)
      : null;

  if (loggedInProvider && loggedInProvider.type !== BASIC_PROVIDER_TYPE && loggedInProvider.logoutUrl) {
    setTimeout(() => {
      window.location.href = loggedInProvider.logoutUrl;
    }, 1000);
  }
};

const processTokenExpirationChecks = (action, store) => {
  const skipActions = [
    'SET_TOKEN_EXPIRATION_INTERVAL_ID',
    'TOKEN_EXPIRATION_CHECK',
    'REFRESH_TOKEN_REQUEST',
    'REFRESH_TOKEN_REQUEST_SUCCESS',
    'REFRESH_TOKEN_REQUEST_ERROR',
    'SET_REFRESH_TOKEN',
    'REMOVE_REFRESH_TOKEN',
    'LOGIN_REQUEST',
    'LOGIN_SUCCESS',
    'LOGIN_ERROR',
    'LOGOUT',
    'SESSION_EXPIRE_DIALOG',
    'IDLE_I2P2_VIZ_APP_START',
    'IDLE_I2P2_VIZ_APP_STOP',
    'IDLE_I2P2_VIZ_APP_ACTIVITY_DETECTION',
  ];

  switch (action.type) {
    case 'LOGIN_SUCCESS':
      setTokenInterval(store);
      break;
    case 'LOGOUT':
      clearTokenInterval(store);
      store.dispatch(idleActions.stop());
      authProviderLogout(store);
      break;
    default:
      if (!skipActions.includes(action.type)) {
        const state = store.getState();
        const now = Date.now();

        if (state.login.isAuthenticated) {
          const lastCheckTimedOut = now - state.login.tokenExpirationLastCheck >= CHECK_EXPIRATION_TIMEOUT_MILLISECONDS;

          if (!state.login.tokenExpirationLastCheck || lastCheckTimedOut) {
            checkTokenExpiration(store);
            setTokenInterval(store);
            store.dispatch(idleActions.start());
          }
        }
      }
  }
};

export const authMiddleware = (store) => (next) => (action) => {
  processTokenExpirationChecks(action, store);

  return next(action);
};
